import { render, staticRenderFns } from "./SwiperItemVideo.vue?vue&type=template&id=5d3fd448&scoped=true"
import script from "./SwiperItemVideo.vue?vue&type=script&lang=js"
export * from "./SwiperItemVideo.vue?vue&type=script&lang=js"
import style0 from "./SwiperItemVideo.vue?vue&type=style&index=0&id=5d3fd448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3fd448",
  null
  
)

export default component.exports